import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Text from '../../../../components/common/text';
import {
  AbbreviatedNumber,
  ChangeIndicatedCurrency,
} from '../../../../components/common/number';

import AssetItem from '../../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
  AssetItemHeaderChange,
} from '../../../../components/asset/asset-item/asset-item-header';

import {
  AssetItemDataText,
  AssetItemDataChange,
} from '../../../../components/asset/asset-item/asset-item-data';
import { Percent } from '../../../../components/common/number';

import TableRow from '../../../../components/common/table-row';
import { factory } from '../../positions/asset-position/asset-position-container';
import { NO_DATA } from '../../../../constants';
import { Large, Small} from '../../../../components/common/text';

import styles from '../../positions/asset-position/asset-position.styles';

class MMInstrumentsPosition extends PureComponent {

  static propTypes = {
    row: PropTypes.shape({
      depositCcy: PropTypes.string,
      security: PropTypes.shape({ name: PropTypes.string }),
      quantity: PropTypes.number,
      marketValue: PropTypes.number,
      unrealisedGL: PropTypes.number,
      unrealisedGLPercent: PropTypes.number,
      proportion: PropTypes.number,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    positionTypeToUse: PropTypes.string,
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
    }),
  };

  renderTopRow() {
    const { row = {}, columnWidths, positionTypeToUse, screen } = this.props;
    const { proportion, name, unrealisedGLPercent } = row;
    const isFunds = positionTypeToUse === 'isFunds';
    const securityName = name && name || NO_DATA;
    var shorten = false;
    if(screen.isSmall){
      shorten = 30;
    }

    return (
      <TableRow style={styles.topRow}>
        <TableRow.Column
          align="left"
          width={columnWidths[0] + columnWidths[1]}
          testID="description"
        >
          <AssetItemHeaderDescription
            row={{
              description: securityName,
            }}
            shorten={shorten}
          />
        </TableRow.Column>
        {
          isFunds && (<TableRow.Column width={columnWidths[2]}>
            <AssetItemHeaderChange value={unrealisedGLPercent} />
          </TableRow.Column>)
        }
      </TableRow>
    );
  }

  renderBottomRow() {
    const { row = {}, columnWidths, positionTypeToUse, screen, messages } = this.props;
    const {
      amount,
      positionCurrency,
      marketValue,
      quantity,
      unrealisedGL,
      isin,
      proportion,
      unrealisedGLPercent,
    } = row;
    const isDeposits = positionTypeToUse === 'deposits';
    const isFunds = positionTypeToUse === 'funds';

    const marketValueOrUnrealisedGLElem = isDeposits && (
      <AbbreviatedNumber
        renderProps={{
          size: 'large',
        }}
        maxDigits={8}
        value={marketValue}
        renderExactAs="currency"
      />
    ) || unrealisedGL && (
      <ChangeIndicatedCurrency
        renderProps={{
          size: 'large',
        }}
        value={unrealisedGL}
      />
    );

    const currencyOrQuantity = isDeposits && (
      <Text size="large">{positionCurrency}</Text>
    ) || quantity && (
      <AbbreviatedNumber
        renderProps={{ size: 'large' }}
        maxDigits={6}
        maxDecimals={4}
        maxDigitsIncludeDecimals={true}
        value={quantity}
      />
    );

    return (
      screen.isSmall ?
      <TableRow style={styles.bottomRow}>
        <TableRow.Column
          align="left"
          width={columnWidths[0]}
        >
          {currencyOrQuantity}
        </TableRow.Column>
        <TableRow.Column width={columnWidths[1]}>
          <AbbreviatedNumber
            renderProps={{
              size: 'large',
            }}
            maxDigits={8}
            value={isDeposits ? amount : marketValue}
            renderExactAs="currency"
          />
        </TableRow.Column>
        <TableRow.Column width={columnWidths[2]}>
          {marketValueOrUnrealisedGLElem}
        </TableRow.Column>
      </TableRow> :
      <TableRow style={styles.bottomRow}>
        <TableRow.Column
          align="left"
          width={columnWidths[0]}
        >
          {currencyOrQuantity}
        </TableRow.Column>
        <TableRow.Column width={columnWidths[1]}>
          <AbbreviatedNumber
            renderProps={{
              size: 'large',
            }}
            maxDigits={8}
            value={isDeposits ? amount : marketValue}
            renderExactAs="currency"
          />
        </TableRow.Column>
        <TableRow.Column width={columnWidths[2]}>
          {marketValueOrUnrealisedGLElem}
        </TableRow.Column>
        {
          isFunds && (
            <TableRow.Column width={columnWidths[3]}>
              <AssetItemHeaderChange value={unrealisedGLPercent} />
            </TableRow.Column>
          )
        }
        <TableRow.Column width={columnWidths[isFunds ? 4 : 3]}>
          <Percent value={proportion}/>
        </TableRow.Column>
      </TableRow>
    );
  }

  render() {
    return (
      <AssetItem>
        {this.renderTopRow()}
        {this.renderBottomRow()}
      </AssetItem>
    );
  }
}

export default factory({
  component: MMInstrumentsPosition,
  assetDataFragmentExtend: {
    positionTypeToUse: true,
  },
  rowFragmentExtend: {
    amount: true,
  },
});
